import script from "./InTarAlm.vue?vue&type=script&lang=ts&setup=true"
export * from "./InTarAlm.vue?vue&type=script&lang=ts&setup=true"

import "./InTarAlm.vue?vue&type=style&index=0&id=7440039e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7440039e"]])

export default __exports__